export enum ClubState {
  UPCOMING = 'UPCOMING',
  LIVE = 'LIVE',
  STAND_BY = 'STAND_BY',
  ARCHIVED = 'ARCHIVED',
}
